import { call, put, takeLatest } from 'redux-saga/effects';
import get from 'lodash/get';

import apis from '../../constants/apis';
import routes from '../../constants/routes';
import { httpClient } from '../../utils';
import { logoutAction, sessionValidateAction, userAuthenticated, userLoggedOut } from './actions';
import { INACTIVE_RENEW_REQUEST, LOGOUT_REQUEST, SESSION_VALIDATE_REQUEST } from './constants';
import { fetchPermission } from '../fccCommon/sagas';

export function* checkSessionValidation() {
  try {
    // const { data } = yield call(httpClient.get, apis.SESSION_RENEW);
    yield* fetchPermission();
    yield put(sessionValidateAction.success());
    yield put(userAuthenticated({}));
  } catch (err) {
    yield put(sessionValidateAction.failure());
  }
}

export function* renew() {
  try {
    yield call(httpClient.get, apis.SESSION_RENEW);
  } catch (err) {
    yield put(sessionValidateAction.failure());
  }
}

export function* processLogout(payload) {
  const isExpired = get(payload, 'data.isExpired', false);
  const history = get(payload, 'data.history', null);
  try {
    if (!isExpired) {
      yield call(httpClient.get, apis.SESSION_RENEW);
    }
    yield put(userLoggedOut());
    yield call(httpClient.post, apis.LOGOUT);
    yield put(logoutAction.success());
    if (history && history.location.pathname === routes.CONTACT_US) {
      history.push(routes.LOGIN);
    }
  } catch (err) {
    yield put(userLoggedOut(err));
  }
}

export default [
  takeLatest(SESSION_VALIDATE_REQUEST, checkSessionValidation),
  takeLatest(INACTIVE_RENEW_REQUEST, renew),
  takeLatest(LOGOUT_REQUEST, processLogout),
];
